import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import postPersonNcsaOptIn from './PostPersonNcsaOptIn';

const INITIAL_STATE = { ...BASIC_INITIAL_STATE };

const PersonNcsaOptInData = { INITIAL_STATE, postPersonNcsaOptIn };
export default PersonNcsaOptInData;
